(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["longleaf-craft"] && !Shopify.designMode) return;
  try {
    
(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const setup = (root) => {
    if (preference.matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('llc-reveal-in');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08 });
    root.querySelectorAll('.llc .llc-section-head, .llc .llc-steps article, .llc .llc-product, .llc .llc-feature-story, .llc .llc-maker-copy, .llc .llc-signup-grid').forEach((element) => {
      if (seen.has(element)) return;
      seen.add(element);
      observer.observe(element);
    });
  };
  setup(document);
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
  preference.addEventListener('change', () => {
    if (preference.matches) document.querySelectorAll('.llc-reveal-in').forEach((element) => element.classList.remove('llc-reveal-in'));
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
